
export enum MediaFileType {
  UNSPECIFIED = "0",
  IMAGE = "IMAGE",
  AUDIO = "AUDIO",
  VIDEO = "VIDEO",
  DOCUMENT = "DOCUMENT"
}
